import config from '../config';

/**
 * 创建大赛接口地址
 * @param apiName 接口名称
 * @returns
 */
export async function createDsbcApiUrl(apiName: string) {
  const svr = config.dsbcLink;
  return `${svr}${/^\//.test(apiName) ? '' : '/'}${apiName}`;
}
